/* Colores en tarjetas (estilo FIGS): cambia foto, enlace y precio en el mismo
   lugar, sin volver a pintar la tarjeta, para que nunca cambie de tamaño. */
(function () {
  function setText(el, text) {
    if (el && text) el.textContent = text;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-card-swatch]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var card = btn.closest('.card-wrapper') || btn.closest('.card');
    if (!card || btn.classList.contains('is-selected')) return;

    var row = btn.closest('[data-card-colors]');
    row.querySelectorAll('[data-card-swatch].is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    setText(row.querySelector('[data-card-color-name]'), btn.dataset.color);

    var media = card.querySelector('.card__media .media');
    if (media && btn.dataset.img) {
      var imgs = media.querySelectorAll('img');
      var img = imgs[0];
      if (img) {
        img.removeAttribute('loading');
        if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
        img.src = btn.dataset.img;
        img.alt = btn.dataset.color;
      }
      var img2 = media.querySelector('img.card-img-2');
      if (btn.dataset.img2) {
        if (!img2) {
          img2 = document.createElement('img');
          img2.className = 'motion-reduce card-img-2';
          img2.width = img ? img.width : 533;
          img2.height = img ? img.height : 666;
          media.appendChild(img2);
        }
        img2.removeAttribute('loading');
        img2.srcset = btn.dataset.srcset2 || '';
        img2.src = btn.dataset.img2;
        img2.alt = btn.dataset.color;
      } else if (img2) {
        img2.remove();
      }
    }

    if (btn.dataset.url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (!a.classList.contains('card-colors__more')) a.href = btn.dataset.url;
      });
    }

    var price = card.querySelector('.price');
    if (price && btn.dataset.price) {
      if (btn.dataset.compare) {
        price.classList.add('price--on-sale');
        setText(price.querySelector('.price__sale .price-item--sale'), btn.dataset.price);
        setText(price.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular'), btn.dataset.compare);
      } else {
        price.classList.remove('price--on-sale');
        setText(price.querySelector('.price__regular .price-item--regular'), btn.dataset.price);
      }
    }
  });
})();

/* "+" Compra rápida en la tarjeta: abre el panel de compra rápida del tema */
document.addEventListener('click', function (event) {
  var plus = event.target.closest('[data-card-quick-add]');
  if (!plus) return;
  event.preventDefault();
  event.stopPropagation();
  var card = plus.closest('.card-wrapper');
  var opener = card && card.querySelector('modal-opener button, .quick-add__submit');
  if (!opener) return;
  var sw = card.querySelector('[data-card-swatch].is-selected');
  var link = card.querySelector('a.full-unstyled-link[href*="/products/"]');
  var url = (sw && sw.dataset.url) || (link && link.getAttribute('href'));
  if (url && opener.hasAttribute('data-product-url')) opener.setAttribute('data-product-url', url);
  opener.click();
});
